import { MonitoringFilterNameDictionary } from '../../../../models';

export class AutomotiveAftermarketFiltersLoad {
  public static readonly type = '[AutomotiveAftermarketFilters] Load';
}

export class AutomotiveAftermarketFiltersUpdate {
  public static readonly type = '[AutomotiveAftermarketFilters] Update';

  constructor(public payload: MonitoringFilterNameDictionary[]) {}
}

export class AutomotiveAftermarketFiltersInitialState {
  public static readonly type = '[AutomotiveAftermarketFilters] Set Initial State';
}
